"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _dom_component = _interopRequireDefault(require("./component/uploader/dom_component"));

var _info = _interopRequireDefault(require("./info"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var Uploader =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Uploader, _PureComponent);

  /**
   * 属性说明
   * @alias UploaderProps
   * @description 上传组件。
   * @property {titleline} 默认支持参数
   * @property {blankline} className;style;id;data-*;accessKey;dir;draggable;tabIndex;title;htmlRef;
   * @property {titleline} 基础属性
   * @property {string} [fileId] 指定"input type=file"的id
   * @property {bool} [autoUpload=true] 是否自动上传
   * @property {bool} [disabled=false] 是否禁用
   * @property {bool} [multiple=false] 是否多选
   * @property {bool} [drag=false] 是否支持拖拽
   * @property {string} [dragOverClassName=''] 拖动到区域添加的className(可用于拖动效果的样式处理)
   * @property {bool} [click=true] 是否支持点击上传
   * @property {string} [accept='*'] 选择的文件类型
   * @property {func} [onFileChange] 文件变化即调用<br />onFileChange(event, isDrag, imageIndex, files)
   * @property {titleline} 触发上传属性
   * @property {string} [name=''] 字段名
   * @property {string} [url=''] 上传的url
   * @property {func} [setUrl] 动态设置上传的url
   * @property {object|function} [data={}] 接口附带的数据
   * @property {object} [headers={}] 请求header参数
   * @property {object} [FileAPIConfig={}] FileAPI上传的配置参数
   * @property {func} [filter] 筛选文件（只适用于支持html5的）<br />filter(fileInfo, event)
   * @property {func} [check] 异步文件检查成功后，调用next继续上传<br />check(fileInfo, next, files) 检查成功后，调用next继续上传
   * @property {func} [canUpload] 是否能够触发上传<br />canUpload(event)
   * @property {func} [onUpload] 开始上传回调<br />onUpload(event, fileInfo)
   * @property {func} [onProgress] 上传过程回调<br />onProgress(progressEvent, fileInfo)
   * @property {func} [onComplete] 上传完成回调<br />onComplete(err, xhr, resp, fileInfo)
   * @property {bool} [unmountInactiveInput=true] 卸载非激活的input结构
   * @property {number} [uploadPoolSize=100] 并发上传池大小，默认100
   */
  function Uploader(props) {
    var _this;

    _classCallCheck(this, Uploader);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Uploader).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "abort", function () {
      if (_this.domRef && (0, _spauiUtils.isFunction)(_this.domRef.abort)) {
        _this.domRef.abort();
      }
    });

    _this.nullList();

    return _this;
  }

  _createClass(Uploader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.nullList();
    }
  }, {
    key: "nullList",
    value: function nullList() {
      this.inputRef = null;
      this.domRef = null;
    } // 给外部获取input框

  }, {
    key: "getInputDOMNode",
    value: function getInputDOMNode() {
      return this.inputRef;
    } // 给外部调用

  }, {
    key: "startUpload",
    value: function startUpload(data, headers, customFiles) {
      if (this.domRef && (0, _spauiUtils.isFunction)(this.domRef.startUpload)) {
        this.domRef.startUpload(data, headers, customFiles);
      }
    } // 给外部调用

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var children = this.props.children;
      return _react["default"].createElement(_dom_component["default"], _extends({}, this.props, {
        inputRef: function inputRef(el) {
          _this2.inputRef = el;
        },
        ref: function ref(el) {
          _this2.domRef = el;
        }
      }), children);
    }
  }]);

  return Uploader;
}(_react.PureComponent); // 组件标记


_defineProperty(Uploader, "propTypes", {
  name: _spauiUtils.PropTypes.string.isRequired,
  url: _spauiUtils.PropTypes.string,
  setUrl: _spauiUtils.PropTypes.func,
  data: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.func, _spauiUtils.PropTypes.object]),
  disabled: _spauiUtils.PropTypes.bool,
  multiple: _spauiUtils.PropTypes.bool,
  drag: _spauiUtils.PropTypes.bool,
  dragOverClassName: _spauiUtils.PropTypes.string,
  headers: _spauiUtils.PropTypes.object,
  FileAPIConfig: _spauiUtils.PropTypes.object,
  click: _spauiUtils.PropTypes.bool,
  accept: _spauiUtils.PropTypes.string,
  filter: _spauiUtils.PropTypes.func,
  check: _spauiUtils.PropTypes.func,
  canUpload: _spauiUtils.PropTypes.func,
  autoUpload: _spauiUtils.PropTypes.bool,
  onUpload: _spauiUtils.PropTypes.func,
  onProgress: _spauiUtils.PropTypes.func,
  onComplete: _spauiUtils.PropTypes.func,
  onFileChange: _spauiUtils.PropTypes.func,
  unmountInactiveInput: _spauiUtils.PropTypes.bool,
  uploadPoolSize: _spauiUtils.PropTypes.number
});

_defineProperty(Uploader, "defaultProps", {
  name: '',
  url: '',
  data: {},
  headers: {},
  FileAPIConfig: {},
  disabled: false,
  multiple: false,
  drag: false,
  dragOverClassName: '',
  click: true,
  autoUpload: true,
  canUpload: function canUpload() {
    return true;
  },
  filter: function filter() {
    return true;
  },
  instanceId: "".concat((0, _utils.uniqueId)(), "-uploader"),
  unmountInactiveInput: true,
  uploadPoolSize: 100
});

(0, _spauiUtils.setComponentMark)(Uploader, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = Uploader;
exports["default"] = _default;